import React, { useEffect, useState } from 'react';
import Reaptcha from 'reaptcha';
import api from '~/services/api';
import ReactTooltip from "react-tooltip";
import {
    ButtonPadraoPrimary,
    InputRadio,
    Form,
    Input,
    GroupInLine,
    ContainerLine,
    Span,
    SpanErrorForm,
    Button,
    Select,
    TextArea
} from '~/styles/CommonStyles';
import Toastify from "~/components/Toastify";
import getUrlParameter from '~/helpers/getURLencode';
import { Container, Perguntas, Pergunta, Aviso, BtnOpcaoResposta, ContainerBtnsResposta, TextareaOpcaoResposta, BtnFinal } from './stylesQuestionario';
import { useRecoilState } from 'recoil';
import { mensagemConformidadeLGPD } from '../../atoms/conformidade';

function Cadastro ( { location } ) {
    const params = new URLSearchParams( location.search );
    const _CHAVE = params.get( 'chave' ) || "Z/ZbpVyPy70HZWGI6OcUhU3nTnB3wXQPWMnPQPkVL7iZHvWwbrKnq6emHNfqI1kOS/YHf/r9X1Y=";
    const _IDQUEST = params.get( 'id' ) || 1120333889;
    const [ perguntas, setPerguntas ] = useState( [] );
    const [ recaptchaToken, setRecaptchaToken ] = useState( null );
    const [ conformidadeMensagem, setConformidadeMensagem ] = useRecoilState( mensagemConformidadeLGPD );

    useEffect( () => {
        if ( !_CHAVE || !_IDQUEST )
            return Toastify.error( 'Erro, chave ou questionario inexistente, por favor entre em contato com medico para que seja enviado um novo link' );
        // if ( recaptchaToken )
        //     getQuestionarioPerguntas();
    }, [ recaptchaToken ] );

    useEffect( () => {
        getQuestionarioPerguntas();
        setConformidadeMensagem( { popUpOpen: true } );
    }, [] );

    async function getQuestionarioPerguntas () {
        try {
            let perquntas = await api.post( 'apoio/getPerguntas', { IddoQuestionario: _IDQUEST, Chave: _CHAVE, responsecaptcha: recaptchaToken } );

            setPerguntas( perquntas.data );

        } catch ( error ) {
            Toastify.error( 'Erro, ' );
            console.log( error );
        }
    };

    function setValor ( index, obj ) {
        let newPerguntas = perguntas.map( ( pergunta, perguntaIndex ) => index == perguntaIndex ? { ...obj } : pergunta );
        setPerguntas( newPerguntas );
    };

    async function salvarRespostas () {
        try {

            if ( !_CHAVE )
                return Toastify.error( 'Por favor, peça que seu medico te envie outro link para respoder o questionario. ' );
            if ( !recaptchaToken )
                return Toastify.warning( 'Por favor, faça a verificação do "captcha" ' );

            let { data } = await api.post( `/apoio/savePerguntas`, perguntas.map( pergunta => ( { ...pergunta, Chave: _CHAVE, responsecaptcha: recaptchaToken, Resposta: pergunta.Resposta ? pergunta.Resposta : '' } ) ) );

            Toastify.success( 'Resposta enviadas com sucesso' );
            return data;
        } catch ( error ) {
            console.log( error );
            Toastify.error( 'Erro ao salvar dados, por favor entre em contato com seu médico' );
            return Promise.reject( error );;
        }
    }

    return (
        <Container>
            <h1 style={ { textAlign: 'center', margin: '10px 0px', displa: 'flex', flex: 'auto 1 0' } }> { perguntas.length ? `Questionario: "${ perguntas[ 0 ].NomedoQuestionario.replace( '.xml', '' ).replace( /[0-9]/g, '' ).replace( '-q-', '' ) }"` : '' }</h1>
            <Perguntas>
                <Aviso >
                    Por favor responda as perguntas abaixo desse questionário.
                Esse questionário tem um total de { perguntas.length } perguntas, faltando responder
            <b style={ { color: 'red', marginLeft: '3px' } }>{ perguntas.filter( pergunta => pergunta.Resposta == null ).length }</b> perguntas.
            </Aviso>
                { perguntas.length && perguntas.map( ( pergunta, indexPegunta ) => {
                    return (
                        <Pergunta key={ pergunta.IddaPergunta } respondida={ pergunta.Resposta != null }>
                            <span>{ pergunta.Pergunta }</span>

                            { pergunta.Tipo == 'SN' &&
                                <article style={ { display: 'flex', justifyContent: 'center', } }>
                                    <div style={ { width: '130px', display: 'flex' } }>
                                        <InputRadio colorChecked="var(--successColor);">
                                            <label htmlFor={ `select-${ pergunta.IddaPergunta }-sim` }>Sim</label>
                                            <input
                                                id={ `select-${ pergunta.IddaPergunta }-sim` }
                                                type="radio"
                                                name={ `select-${ pergunta.IddaPergunta }` }
                                                onChange={ ( e ) => setValor( indexPegunta, { ...pergunta, Resposta: '5' } ) }
                                                checked={ pergunta.Resposta == '5' }
                                            />
                                            <span ></span>
                                        </InputRadio>
                                        <InputRadio colorChecked="var(--successColor);">
                                            <label htmlFor={ `select-${ pergunta.IddaPergunta }-nao` }>Não</label>
                                            <input
                                                id={ `select-${ pergunta.IddaPergunta }-nao` }
                                                type="radio"
                                                name={ `select-${ pergunta.IddaPergunta }` }
                                                onChange={ ( e ) => setValor( indexPegunta, { ...pergunta, Resposta: '1' } ) }
                                                checked={ pergunta.Resposta == '1' }
                                            />
                                            <span></span>
                                        </InputRadio>
                                    </div>
                                </article>
                            }
                            { pergunta.Tipo == 'Intensidade' &&
                                <article style={ { display: 'flex', justifyContent: 'center', width: '100%' } }>
                                    <ContainerBtnsResposta >
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '0' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '0' } ) }>Nada</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '1' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '1' } ) }>Muito pouco</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '2' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '2' } ) }>Moderado</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '3' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '3' } ) }>Intenso</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '4' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '4' } ) }>Muito intenso</BtnOpcaoResposta>
                                    </ContainerBtnsResposta>
                                </article>
                            }
                            { pergunta.Tipo == 'Frequência' &&
                                <article style={ { display: 'flex', justifyContent: 'center', width: '100%' } }>
                                    <ContainerBtnsResposta >
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '0' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '0' } ) }>Nunca</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '1' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '1' } ) }>Raramente</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '2' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '2' } ) }>Às vezes</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '3' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '3' } ) }>Frequentemente</BtnOpcaoResposta>
                                        <BtnOpcaoResposta selected={ pergunta.Resposta == '4' } onClick={ () => setValor( indexPegunta, { ...pergunta, Resposta: '4' } ) }>Sempre</BtnOpcaoResposta>
                                    </ContainerBtnsResposta>
                                </article>
                            }
                            { pergunta.Tipo == 'Texto' &&
                                <article style={ { display: 'flex', justifyContent: 'center', width: '100%' } }>
                                    <ContainerBtnsResposta >
                                        <TextareaOpcaoResposta 
                                                style={ { width: '100%', height: '100px', padding: '10px', borderRadius: '5px', border: '1px solid var(--primaryColor)', fontSize: '1.2rem',resize:'none' } }
                                                value={ pergunta.Resposta } 
                                                onChange={ ( e ) => setValor( indexPegunta, { ...pergunta, Resposta: e.target.value } ) }/>

                                        
                                    </ContainerBtnsResposta>
                                </article>
                            }

                        </Pergunta>
                    );
                } ) }

                <BtnFinal >
                    <Reaptcha
                        sitekey="6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3"
                        onVerify={ ( value ) => setRecaptchaToken( value ) }
                        onExpire={ () => setRecaptchaToken( null ) }
                    />
                    <a data-tip data-for='btnHome' >
                        <ButtonPadraoPrimary disabled={ !recaptchaToken } onClick={ () => salvarRespostas() } >Enviar Respostas</ButtonPadraoPrimary>
                    </a>
                    <ReactTooltip delayShow={ 300 } id='btnHome' place="bottom" type="dark" effect="solid">
                        { recaptchaToken ? <span>Enviar Respostas</span> : <span>Antes selecione o captcha de verificação (Não sou o robô)</span> }
                    </ReactTooltip>

                </BtnFinal>

            </Perguntas>
        </Container>
    );
}

export default Cadastro;

